import {Injectable} from "@angular/core";

export interface Language {
  readonly code: string;
  readonly name: string;
}

@Injectable({
  providedIn: "root"
})
export class LanguageDataService {

  public getLanguages(): Promise<Language[]> {
    // Use hardcoded data for now.
    return Promise.resolve(LANGUAGES.slice());
  }

}

const LANGUAGES: ReadonlyArray<Language> = [
  {code: "de", name: "Deutsch"},
  {code: "fr", name: "Français"},
  {code: "it", name: "Italiano"},
  {code: "en", name: "English"},
];
